(function ($) {
  Drupal.behaviors.sppProductLayoutV3 = {
    attach: function (context) {
      var $template = $('.js-spp-product-layout-v3', context);
      var $expanderSections = $('.js-product-content-item', $template);
      var $ratingsTitle = $expanderSections.find('.js-pr-rating-tab');
      var $ratingsSectionTitle = $expanderSections.find('.js-spp-reviews-content');
      var $showFindShadeOverlay = $template.find('.js-show-find-shade-overlay');
      var $prodFindShadeOverlay = $template.find('.js-product-find-shade-content');
      var $prodFindShadeOverlayTab = $prodFindShadeOverlay.find('.js-product-find-shade-overlay-tab:not(.disabled)');

      if (this.attached) {
        return;
      }
      this.attached = true;

      // Populate ratings header
      if ($ratingsTitle.length > 0 && $ratingsSectionTitle.length > 0) {
        $ratingsSectionTitle.html($ratingsTitle.html());
      }

      // Section expanders
      if ($expanderSections.length > 0) {
        $expanderSections.each(function () {
          var $this = $(this);
          var $trigger = $this.find('.js-product-content-item-heading');

          $trigger.once().on('click', function () {
            var $currentHeading = $(this);
            var $content = $currentHeading.next('.js-product-content-item-content');
            var expanded = $currentHeading.attr('aria-expanded') === 'false' ? false : true;

            $currentHeading.attr('aria-expanded', !expanded);
            $content.attr('aria-hidden', expanded);
          });
        });
      }

      $showFindShadeOverlay.once().on('click', function (event) {
        event.preventDefault();
        if ($prodFindShadeOverlayTab.length > 0) {
          $prodFindShadeOverlayTab.eq(0).trigger('launch.findShadeTabbed');
        }
      });
    },
    attached: false
  };
})(jQuery);
